<template>
  <div
    class="swiperBox"
    :style="{ position: 'relative', height: styles.height + 'px' }"
  >
    <div
      class="swiper-container"
      :style="{
        width: styles.width + 'px',
        position: 'absolute',
        height: styles.height + 'px',
        left: '50%',
        marginLeft: '-960px'
      }"
    >
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in sliderData"
          :key="index"
          class="swiper-slide"
        >
          <img :src="item.FileUrl" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <!-- <div class="swiper-pagination"></div> -->

      <!-- 如果需要导航按钮 -->
      <!-- <div  v-if="sliderData.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
    <div  v-if="sliderData.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

// import 'swiper/css/swiper.min.css';
export default {
  name: "Slider",
  props: {
    sliderData: {
      // 图片列表 src数组
      type: Array,
      default: () => []
    },
    isShowPosition: {
      // 是否显示下方小圆点
      type: Boolean,
      default: true
    },
    isShowLeftOrRightBtn: {
      // 是否显示左右按钮
      type: Boolean,
      default: true
    },
    duration: {
      // 切换间隔
      type: [Number, String],
      default: 5000
    },
    animationT: {
      type: Object,
      default: () => {
        return {
          speed: 20,
          speedTime: 20
        };
      }
    },
    styles: {
      // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 420
        };
      }
    }
  },
  data() {
    return {
      active: 1, // 当前轮播图片
      timer: null, // 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: document.body.clientWidth // 屏幕宽度
    };
  },
  mounted() {
    if (this.sliderData.length > 1) {
      var mySwiper1 = new Swiper(".swiperBox .swiper-container", {
        loop: true,
        // 如果需要分页器
        pagination: ".swiperBox .swiper-pagination",
        // 如果需要前进后退按钮

        nextButton: ".swiperBox .swiper-button-next",
        prevButton: ".swiperBox .swiper-button-prev"
      });
    }
  }
};
</script>
<style>
.swiperBox {
  width: 100%;
  height: 420px;
  overflow: hidden;
  margin-top: -20px;
}
.swiperBox .swiper-container {
  width: 100%;
  height: 420px;
}
.swiperBox .swiper-wrapper {
  width: 100%;
  height: 420px;
}
.swiperBox .swiper-slide {
  width: 100%;
  height: 420px;
}
.swiperBox .swiper-slide a {
  display: block;
  width: 100%;
  height: 100%;
}
.swiperBox .swiper-pagination,
.swiper-pagination-bullets {
  font-size: 0 !important;
  bottom: 20px !important;
}
.swiperBox .swiper-pagination-bullet {
  width: 8px !important;
  height: 8px !important;
  background-color: #cccccc !important;
  border-radius: 50% !important;
  opacity: 1 !important;
}
.swiperBox .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 40px !important;
  height: 8px !important;
  background-color: #0376be !important;
  border-radius: 4px !important;
  opacity: 1 !important;
  transition: all 0.3s !important;
}
</style>



// WEBPACK FOOTER //
// src/components/slider.vue